import { useMemo } from 'react';

import { JSONObject } from 'global/graphql/scalars.type';
import { getExtensions } from 'approot/shared/richtext/richtext.utils';
import { formatSubActivityLabel } from '../sub-activity/sub-activity.utils';
import { SUB_ACTIVITY_INSTRUCTION_SETTINGS } from '../sub-activity/sub-activity.constants';
import {
  getRichtextValue,
  isRichtextValueEmpty,
} from '../shared/logic/get-richtext-value';
import * as Styled from './suggested-answer-title.style';

type Props = {
  label?: string | null;
  isSmall?: boolean;
  isLarge?: boolean;
  instructions?: JSONObject | null;
};

const SuggestedAnswerTitle = ({
  label,
  isSmall,
  isLarge,
  instructions,
}: Props) => {
  const extensions = useMemo(
    () => getExtensions(SUB_ACTIVITY_INSTRUCTION_SETTINGS),
    []
  );

  if (!instructions) return null;

  return (
    <Styled.SuggestedAnswerTitleRichtextOverride
      $isSmall={isSmall}
      $isLarge={isLarge}
    >
      {label && <p>{formatSubActivityLabel(label)}</p>}
      {!isRichtextValueEmpty(instructions) && (
        <span
          dangerouslySetInnerHTML={{
            __html: getRichtextValue(instructions, extensions),
          }}
        />
      )}
    </Styled.SuggestedAnswerTitleRichtextOverride>
  );
};

export default SuggestedAnswerTitle;
